module.exports = __webpack_public_path__ + "static/media/400398_01.b7285809.png";